import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/Store";
import App from "./App";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./main.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// Register Progressive Web App Service Worker for offline caching & fast mobile loading
serviceWorkerRegistration.register();

reportWebVitals();
